function getStorageKey(popupId: string): string {
    return `${popupId}-popup-hide-timestamp`;
}

function readHideTimestamp(popupId: string): number | null {
    try {
        const rawTimestamp = localStorage.getItem(getStorageKey(popupId));

        if (rawTimestamp === null) {
            return null;
        }

        const timestamp = parseInt(rawTimestamp, 10);

        return Number.isNaN(timestamp) ? null : timestamp;
    } catch {
        return null;
    }
}

export const popupStorage = {
    markHidden(popupId: string): void {
        try {
            localStorage.setItem(getStorageKey(popupId), String(Date.now()));
        } catch {}
    },

    isHiddenWithin(popupId: string, durationMilliseconds: number): boolean {
        const hideTimestamp = readHideTimestamp(popupId);

        if (hideTimestamp === null) {
            return false;
        }

        return Date.now() - hideTimestamp < durationMilliseconds;
    },

    removeIfExpired(popupId: string, durationMilliseconds: number): void {
        const hideTimestamp = readHideTimestamp(popupId);

        if (hideTimestamp === null) {
            return;
        }

        if (Date.now() - hideTimestamp >= durationMilliseconds) {
            this.remove(popupId);
        }
    },

    remove(popupId: string): void {
        try {
            localStorage.removeItem(getStorageKey(popupId));
        } catch {}
    },
};